import { css } from '@emotion/core';

import { margin, shadowBorder } from 'src/design-system/mixins';
import { Margins, Responsive } from 'src/design-system/style-types';
import { Theme } from 'src/design-system/theme';

const container =
  ({
    marginTop,
    marginBottom,
    disabled,
  }: {
    marginTop: Responsive<Margins>;
    marginBottom: Responsive<Margins>;
    disabled: boolean;
  }) =>
  (theme: Theme) =>
    css`
      /* Customize the label (the container) */
      display: flex;
      position: relative;
      padding-left: 28px;
      ${margin({ marginTop })(theme)}
      ${margin({ marginBottom })(theme)}
      ${!disabled &&
      css`
        cursor: pointer;
      `};
      user-select: none;
      align-items: center;

      /* Create a custom radio button */
      .checkmark {
        position: absolute;
        left: 0;
        height: 20px;
        width: 20px;
        box-shadow: inset 0 0 0 1px ${theme.fontColors.dark};
        border-radius: 50%;
      }

      /* Create the indicator (the dot/circle - hidden when not checked) */
      .checkmark:after {
        content: '';
        position: absolute;
        display: none;
      }

      /* Show the indicator (dot/circle) when checked */
      &[aria-checked='true'] > .checkmark:after {
        display: block;
      }

      /* Style the indicator (dot/circle) */
      .checkmark:after {
        top: 6px;
        left: 6px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${theme.fontColors.dark};
      }

      &[aria-disabled='true'] {
        cursor: default;
      }

      &[aria-disabled='true'] > .checkmark {
        ${shadowBorder('grey')(theme)}
      }

      &[aria-disabled='true'] > .checkmark:after {
        background: ${theme.colors.grey} !important;
      }
    `;

export const style = { container };
